import cx from "classnames";
import type { FC, ReactNode } from "react";

import "./Spinner.scss";

export interface SpinnerProps {
	sm?: boolean;
	inline?: boolean;
	inverse?: boolean;
	children?: ReactNode;
}

const Spinner: FC<SpinnerProps> = (props) => {
	return (
		<span>
			<span
				className={cx("spinner", {
					"spinner-sm": props.sm,
					"spinner-inline": props.inline,
					"spinner-inverse": props.inverse,
				})}
				role="progressbar"
				aria-label="Loading..."
				aria-valuetext="Loading..."
			></span>
			{props.children}
		</span>
	);
};

export default Spinner;
